import * as React from 'react';
import { Button } from 'antd';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from "src/core/Routes";
import { withLocalize, LocalizeContextProps, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import GuideSection from '../../components/public/GuideSection';


interface RouteProps {
    gradeId: number;
}

interface ParentsObjectivesProps extends PageProps<RouteProps>, LocalizeContextProps {
}

class ParentsObjectives extends React.Component<ParentsObjectivesProps> {
    constructor(props: ParentsObjectivesProps) {
        super(props);
        bindAllOfThis(this, ParentsObjectives.prototype);
    }

    private getListFromJSON(path: string, length: number) {
        let list = [];

        if (!path.endsWith('.')) {
            path += '.';
        }
        for (var i = 1; i <= length; ++i) {
            var translationKey = path + i;

            if (!this.props.translate(translationKey)) {
                break;
            }

            list.push(translationKey);
        }

        return list;
    }

    render() {
        let objectives = this.getListFromJSON("public.parents.grade" + this.props.match.params.gradeId + ".objectives.objective.", 12);

        return <div className="parents-portal">
            <h2><Translate id="public.parents.pageHeader" /></h2>
            <h3><Translate id={"public.parents.grade" + this.props.match.params.gradeId + ".objectives.header"} /></h3>
            <GuideSection
                bodyKey={"public.parents.grade" + this.props.match.params.gradeId + ".objectives.body"}
                listBodyKeys={objectives}
            />
            <Link to={Routes.getRoute(Routes.PARENTS, this.props.match.params.gradeId)}>
                <Button icon="left"><Translate id="common.back" /></Button>
            </Link>
        </div>;
    }
}

export default withLocalize(ParentsObjectives as any) as any;



// WEBPACK FOOTER //
// ./src/pages/public/ParentsObjectives.tsx